import React from 'react';

export const PLATFORM = {
    WIN_PHONE: 1,
    ANDROID: 2,
    IOS: 3,
    OTHER: 0,
};

const getPlatform = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) return PLATFORM.WIN_PHONE; // Windows Phone must come first because its UA also contains "Android"
    if (/android/i.test(userAgent)) return PLATFORM.ANDROID;
    if (/iPad|iPhone|iPod/i.test(userAgent)) return PLATFORM.IOS;
    return PLATFORM.OTHER;
};

export const platform = getPlatform();
